/* eslint-disable max-len */
import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './LowPower.scss';

const LowPower = (props) => (
    <Icon iconName="LowPower" {...props}>
        <svg width="66px" height="28px" viewBox="0 0 66 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-415.000000, -104.000000)">
                    <g transform="translate(415.000000, 104.000000)">
                        <g transform="translate(0.000000, 0.566700)">
                            <path
                                d="M22.6646,23.1582 L8.0516,23.1582 C5.5826,23.1582 3.5806,21.1572 3.5806,18.6882 L3.5806,7.7452 C3.5806,5.2762 5.5826,3.2752 8.0516,3.2752 L22.6646,3.2752 C25.1336,3.2752 27.1346,5.2762 27.1346,7.7452 L27.1346,18.6882 C27.1346,21.1572 25.1336,23.1582 22.6646,23.1582"
                                fill="#E1B00F"
                            />
                            <path
                                d="M55.1207,26.25 L6.5337,26.25 C3.3397,26.25 0.7497,23.661 0.7497,20.467 L0.7497,5.967 C0.7497,2.772 3.3397,0.183 6.5337,0.183 L55.1207,0.183 C58.3147,0.183 60.9037,2.772 60.9037,5.967 L60.9037,20.467 C60.9037,23.661 58.3147,26.25 55.1207,26.25 Z"
                                stroke="#FFFFFF"
                                strokeWidth="1.5"
                            />
                            <polygon
                                stroke="#FFFFFF"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                points="11.7725 19.4068 11.7725 14.2168 9.0625 14.2168 13.4085 7.0268 13.4085 11.6878 16.2935 11.6878"
                            />
                        </g>
                        <path
                            d="M63.6582,20.9266 L60.9042,20.9266 L60.9042,8.6406 L63.6582,8.6406 C64.4662,8.6406 65.1212,9.2956 65.1212,10.1026 L65.1212,19.4636 C65.1212,20.2716 64.4662,20.9266 63.6582,20.9266 Z"
                            stroke="#FFFFFF"
                            strokeWidth="1.5"
                        />
                    </g>
                </g>
            </g>
        </svg>
    </Icon>
);

export default LowPower;
